<script lang="ts">
  import { Card, Col, Image } from "sveltestrap";
  import PostHeader from "./PostHeader.svelte";
  import PostBody from "./PostBody.svelte";
  import Link from "svelte-link";
  let imgPath:string = "/assets/images/user-profile"
</script>
<Col sm="12">
  <Card>
    <div class="profile-post">
      <PostHeader image={"7.jpg"} hours={2}/>
      <div class="post-body">
        <div class="img-container">
          <div class="my-gallery" id="aniimated-thumbnials" itemscope>
            <figure itemprop="associatedMedia" itemscope>
              <Link href="{imgPath}/post4.jpg" itemprop="contentUrl" data-size="1600x950">
                <Image fluid class="rounded" src="{imgPath}/post4.jpg" itemprop="thumbnail" alt="gallery" />
              </Link>
            </figure>
          </div>
        </div>
        <PostBody people={20} likes={407} comments={302} shares={180}/>
      </div>
    </div>
  </Card>
</Col>